import { render } from "./NavBarShop.vue?vue&type=template&id=aaebefd4&scoped=true"
import script from "./NavBarShop.vue?vue&type=script&lang=js"
export * from "./NavBarShop.vue?vue&type=script&lang=js"

import "./NavBarShop.vue?vue&type=style&index=0&id=aaebefd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaebefd4"]])

export default __exports__